import { ReactComponent as FacebookIcon } from "../../assets/icons/facebook.svg";
import { ReactComponent as InstagramIcon } from "../../assets/icons/instagram.svg";

const socialLinks = [
  { href: "https://facebook.com", label: "Facebook", icon: "facebook" },
  { href: "https://instagram.com", label: "Instagram", icon: "instagram" },
] as const;

function SocialIcon({
  icon,
}: {
  icon: "facebook" | "instagram";
}): React.JSX.Element {
  if (icon === "facebook") {
    return <FacebookIcon aria-hidden="true" focusable="false" />;
  }

  return <InstagramIcon aria-hidden="true" focusable="false" />;
}

type SocialLinksProps = {
  className: string;
};

function SocialLinks({ className }: SocialLinksProps) {
  return (
    <div className={className}>
      {socialLinks.map((link) => (
        <a
          key={link.label}
          className="social-link"
          href={link.href}
          target="_blank"
          rel="noreferrer"
          aria-label={link.label}
          title={link.label}
        >
          <SocialIcon icon={link.icon} />
        </a>
      ))}
    </div>
  );
}

export default SocialLinks;
